import { render, staticRenderFns } from "./barra.vue?vue&type=template&id=2132ebf2&"
import script from "./barra.vue?vue&type=script&lang=js&"
export * from "./barra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports